import { SYNCHRO_GET_API_HABILITATIONS } from "./habilitationsConstants";

export function habilitations(state = [], action) {
    switch (action.type) {
        case SYNCHRO_GET_API_HABILITATIONS:
            if (!action.habilitations) {
                return null
            }
            return action.habilitations;
        default:
            return state;
    }
}
